var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0224 13.7656C22.7912 13.5344 22.4163 13.5344 22.1851 13.7656L17.9983 17.9523L13.8113 13.7653C13.5801 13.5341 13.2052 13.5341 12.974 13.7653C12.7427 13.9965 12.7427 14.3714 12.974 14.6026L17.161 18.7897L12.9741 22.9766C12.7428 23.2078 12.7428 23.5827 12.9741 23.8139C13.2053 24.0452 13.5802 24.0452 13.8114 23.8139L17.9983 19.627L22.185 23.8136C22.4162 24.0449 22.7911 24.0449 23.0223 23.8136C23.2536 23.5824 23.2536 23.2075 23.0223 22.9763L18.8357 18.7897L23.0224 14.603C23.2537 14.3717 23.2537 13.9968 23.0224 13.7656Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBurger);
export default __webpack_public_path__ + "static/media/close-burger.ccf72ae429aad9ba75bca108be65f5d5.svg";
export { ForwardRef as ReactComponent };